<template>
	<div class="additions">
		<table>
			<tr v-if="isListStyling">
				<td>{{ list }}</td>
			</tr>
			<template v-else>
				<tr v-if="experience">
					<td>Erfahrung:</td>
					<td>{{ experience }}</td>
				</tr>
				<tr v-if="selfAssessment">
					<td>Kenntnisse:</td>
					<td>{{ selfAssessment }}</td>
				</tr>
				<tr v-if="supplements">
					<td colspan="2">{{ supplements }}</td>
				</tr>
				<template v-if="specificities">
					<tr v-for="item in specificities">
						<td v-if="item.label">{{ item.label }}:</td>
						<td>{{ item.value }}</td>
					</tr>
				</template>
			</template>
			<tr v-if="withEditButton || deletable" class="actions">
				<td colspan="2">
					<a v-if="withEditButton" href="#" @click.prevent="$emit('edit')">
						<Icon icon="pencil"/>
						Bearbeiten
					</a>
					<a v-if="deletable" href="#" @click.prevent="$emit('delete')">
						<Icon icon="bin"/>
						Löschen
					</a>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";

export default {

	components: {
		Icon,
	},

	props: {
		isListStyling: {
			type: Boolean,
			required: false,
			default: false
		},
		list: {
			type: String,
			required: false,
		},
		experience: {
			type: String,
			required: false,
		},
		selfAssessment: {
			type: String,
			required: false,
		},
		supplements: {
			type: String,
			required: false,
		},
		specificities: {
			type: Array,
			required: false
		},
		withEditButton: {
			type: Boolean,
			required: false,
			default: false
		},
		deletable: {
			type: Boolean,
			required: false,
			default: false
		},
	}
}
</script>